import { createAction } from 'redux-actions';

export const clearInventoryAuditLogs = createAction(
  'CLEAR_INVENTORY_AUDIT_LOGS'
);

export const clearInventoryAuditLogsSearchOptions = createAction(
  'CLEAR_INVENTORY_AUDIT_LOGS_SEARCH_OPTIONS'
);

export const inventoryAuditLogsOnChangePage = createAction(
  'INVENTORY_AUDIT_LOGS_ON_CHANGE_PAGE'
);
